import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  COLORS,
  Flex,
  Grid,
  SxProps,
  Typography,
} from '@dripcapital/dripui-v1';
import Email from '@mui/icons-material/Email';

type AgentProps = {
  name?: string;
  email?: string;
};

const TalkToAgentCard: React.FC<AgentProps> = ({
  email = 'xxxxxwis@dripcapital.com',
}: AgentProps) => {
  const { t } = useTranslation();

  const style: SxProps = {
    // padding: 0.8,
    color: COLORS.SECONDARY,
    fontSize: 14,
  };

  return (
    <Box>
      <Grid container dataTestId="talk-to-agent-card" rowSpacing={1}>
        <Grid xs={11} _sx={style} item>
          <Flex alignItems={'center'} direction="row">
            <Typography
              variant="caption"
              fontWeight="bold"
              _sx={{ color: COLORS.SECONDARY }}
            >
              {t('label_contact_agent')}
            </Typography>
          </Flex>
        </Grid>
        <Grid xs={11} _sx={style} item>
          <Flex alignItems={'center'} direction="row">
            <Email sx={{ marginRight: 1 }} />
            <a
              href={`mailto:${email}`}
              style={{
                color: COLORS.PRIMARY,
                wordBreak: 'break-all',
              }}
            >
              {email}
            </a>
          </Flex>
        </Grid>
        <Grid xs={11} _sx={style} item>
          <Flex alignItems={'center'} direction="row">
            <Box>
              <Typography
                variant="body-small"
                fontWeight="bold"
                _sx={{ display: 'inline' }}
              >
                {t('label_contact_agent_note')}
              </Typography>
              <Typography variant="body-small" _sx={{ display: 'inline' }}>
                {t('label_contact_agent_note_info1')}{' '}
                <a
                  href={'mailto:financeops@dripcapital.com'}
                  style={{
                    color: COLORS.PRIMARY,
                    wordBreak: 'break-all',
                    display: 'inline',
                  }}
                >
                  {t('label_contact_agent_email')}
                </a>{' '}
                {t('label_contact_agent_note_info2')}
              </Typography>
            </Box>
          </Flex>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TalkToAgentCard;
